import styled from "styled-components";

export const Title = styled.h4`
  font-family: "Nunito";
  font-weight: 700;
  font-size: 20px;
  color: #293134;
  @media (min-width: 1900px) {
    font-size: 28px;
  }
`;

export const SubTitle = styled.h6`
  font-family: "Nunito";
  font-weight: 600;
  font-size: 12px;
  color: #777777;
  @media (min-width: 1900px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const Label = styled.label`
  font-family: "Nunito";
  font-weight: 700;
  font-size: 14px;
  color: #293134;
  margin-bottom: 0px;
  @media (min-width: 1900px) {
    line-height: 17px;
    font-size: 18px;
    margin-bottom: 5px;
  }
`;

export const InputContainer = styled.div`
  margin-bottom: 8px;
  @media (min-width: 1900px) {
    margin-bottom: 15px;
  }
`;

export const Input = styled.input`
  height: 35px;
  font-size: 14px;
  background: #f3f3f3 !important;
  font-family: "Nunito";
  font-weight: 500;
  color: #293134 !important;
  border-radius: 5px;
  border: none;
  padding: 8px;

  &:-webkit-autofill {
    background-color: rgba(239, 225, 215, 0.5) !important; /* Un tono más oscuro */
    -webkit-box-shadow: 0 0 0px 1000px rgba(239, 225, 215, 0.5) inset !important;
    box-shadow: 0 0 0px 1000px rgba(239, 225, 215, 0.5) inset !important;
  }

  @media (min-width: 1900px) {
    line-height: 28px;
    height: 40px;
    font-size: 18px;
    padding: 10px;
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5px;
  margin-bottom: 8px;
  a {
    font-family: "Nunito";
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    color: #293134 !important;
  }

  a:hover {
    color: #f0292a !important;
    cursor: pointer;
  }
`;
